import { NAV_LINKS } from "@/data/content";

const productLinks = ["Verified Manufacturers™", "RFQ™", "CommodityBid™", "SmartContainer™", "FreightIQ™", "Exception Hub™"];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center">
              <span className="text-[15px] font-semibold text-white font-heading">Verified Manufacturers™</span>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">A DeMaxtore Workspace Product for supplier verification. Source with confidence from export-ready Turkish manufacturers.</p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Explore</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (<li key={l.href}><a href={l.href} className="text-sm text-slate-400 hover:text-white transition-colors">{l.label}</a></li>))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Workspace Products</h4>
            <ul className="mt-4 space-y-2.5">
              {productLinks.map((p) => (<li key={p}><a href="#top" className="text-sm text-slate-400 hover:text-white transition-colors">{p}</a></li>))}
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} DeMaxtore. Verified Manufacturers™ is a DeMaxtore Workspace Product.</p>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <a href="#top" className="hover:text-white transition-colors">Privacy</a>
            <a href="#top" className="hover:text-white transition-colors">Terms</a>
            <a href="#top" className="hover:text-white transition-colors">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
